import type { AccountBalanceResponse } from 'mmfintech-backend-api/types'

// USD accounts without an IBAN show their account number instead
export const getUsdAccountNumber = (account?: AccountBalanceResponse): string | undefined => {
  const bankAccount = account?.dedicatedMerchantBankAccounts?.[0]
  return account?.currencyCode === 'USD' && !bankAccount?.iban ? bankAccount?.accountNumber : undefined
}
